// extracted by mini-css-extract-plugin
export var header = "_t5-1";
export var maskBottom = "_t5-6";
export var maskMiddle = "_t5-7";
export var maskTop = "_t5-5";
export var root = "_t5-0";
export var scrollDownButton = "_t5-3";
export var scrollDownButtonHidden = "_t5-4";
export var viewport = "_t5-2";